import React, { Component } from 'react';

import CookieConsent from "react-cookie-consent";
import {BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Cookies from 'universal-cookie';

import LandingPage from "./pages/LandingPage";
import MindannyiunkHangja from "./pages/MindannyiunkHangja";
import EpitettTermeszetiOrokseg from "./pages/EpitettTermeszetiOrokseg";
import KornyezetunkMegovasa from "./pages/KornyezetunkMegovasa";
import Kozegeszsegugy from "./pages/Kozegeszsegugy";

import KozlekedesiAnomaliak from "./pages/KozlekedesiAnomaliak";
import MeltoIdoskor from "./pages/MeltoIdoskor";
import OktatasMunkaVilaga from "./pages/OktatasMunkaVilaga";
import PenzugyiForrasok from "./pages/PenzugyiForrasok";
import LakhatasLakasfenntartas from "./pages/LakhatasLakasfenntartas";

import ProgramokBaj from "./pages/ProgramokBaj";
import ProgramokSzarliget from "./pages/ProgramokSzarliget";
import ProgramokTata from "./pages/ProgramokTata";
import ProgramokTatabanya from "./pages/ProgramokTatabanya";
import ProgramokVertesszolos from "./pages/ProgramokVertesszolos";
import AdatkezelesiTajekoztato from "./components/AdatkezelesiNyilatkozat/AdatkezelesiTajekoztato";

const cookies = new Cookies();

class App extends Component {
	state = {};

  onCookieConsent = () => {
    cookies.set('CookieConsent', 'true', {
        path: '/'
    })
  }


	render() {
		return (
			<>

			<Router>
          <Route path="/" exact>
            <LandingPage {...this} {...this.props}/>
          </Route>
					<Route path="/MindannyiunkHangja" exact>
            <MindannyiunkHangja {...this} {...this.props}/>
          </Route>
					<Route path="/EpitettTermeszetiOrokseg" exact>
            <EpitettTermeszetiOrokseg {...this} {...this.props}/>
          </Route>
					<Route path="/KornyezetunkMegovasa" exact>
            <KornyezetunkMegovasa {...this} {...this.props}/>
          </Route>
					<Route path="/Kozegeszsegugy" exact>
            <Kozegeszsegugy {...this} {...this.props}/>
          </Route>
					<Route path="/KozlekedesiAnomaliak" exact>
            <KozlekedesiAnomaliak {...this} {...this.props}/>
          </Route>
					<Route path="/MeltoIdoskor" exact>
            <MeltoIdoskor {...this} {...this.props}/>
          </Route>
					<Route path="/OktatasMunkaVilaga" exact>
            <OktatasMunkaVilaga {...this} {...this.props}/>
          </Route>
					<Route path="/PenzugyiForrasok" exact>
            <PenzugyiForrasok {...this} {...this.props}/>
          </Route>
					<Route path="/LakhatasLakasfenntartas" exact>
            <LakhatasLakasfenntartas {...this} {...this.props}/>
          </Route>

					<Route path="/ProgramokBaj" exact>
            <ProgramokBaj {...this} {...this.props}/>
          </Route>
					<Route path="/ProgramokSzarliget" exact>
            <ProgramokSzarliget {...this} {...this.props}/>
          </Route>
					<Route path="/ProgramokTata" exact>
            <ProgramokTata {...this} {...this.props}/>
          </Route>
					<Route path="/ProgramokTatabanya" exact>
            <ProgramokTatabanya {...this} {...this.props}/>
          </Route>
					<Route path="/ProgramokVertesszolos" exact>
            <ProgramokVertesszolos {...this} {...this.props}/>
          </Route>
					<Route path="/AdatkezelesiTajekoztato" exact>
            <AdatkezelesiTajekoztato {...this} {...this.props}/>
          </Route>


      </Router>
		{/*<CookieConsent
			location="bottom"
			disableStyles={true}
			buttonText="Elfogadom"
			cookieName="myAwesomeCookieName2"
			buttonClasses="btn btn-akzeptiren-cookies"
			contentClasses="cookies-content"
			buttonWrapperClasses="cookies-btn-wrapper"
			expires={150}
		>
			<h5 className="cookies-text-title"><img src={cookiesicon}/>{t('wir_verwenden_cookies')}</h5>
			<p>{t('um_ihnen_die_bestmögliche')}</p>
                <p>{t('weitere_informationen_finden')}<a id="1" href="/Datenschutzrichtlinien" target="_blank">{t('datenschutzinformation')}</a>{t('bitte_beachten_sie')}</p>
		</CookieConsent>*/}

</>
		);
	}
}

export default App;
